export default function(date) {
  /* eslint-disable */
  let reg = new RegExp("^[0-9]{2}/[0-9]{2}/[0-9]{4}$");
  return reg.test(date);
}
